<template>
  <CRow class="mainDetail">
    <CCol sm="12" class="mb-4" v-if="loading">
      <div class="d-flex flex-column justify-content-center align-items-center bg-gray-200 p-5">
        <CSpinner class="my-3" color="primary" />
      </div>
    </CCol>
    <CCol sm="12" class="mb-5">
      <a @click="$router.go(-1)" class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600">
        <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
        {{ $t('audience.history.button.back') }}
      </a>
    </CCol>
    <CCol sm="12" class="mb-4" v-if="recipientNotFound">
      <!-- <div
        class="d-flex flex-column justify-content-center align-items-center bg-gray-200 p-5">
          <p>recipient Not Found</p>
      </div> -->

      <div v-show="messages.length">
        <CAlert :color="item.status" v-for="(item, i) in messages" closeButton :key="i">
          {{ item.text }}
        </CAlert>
      </div>
    </CCol>
    <CCol sm="12" class="mainDetail__notFound my-4" v-show="!recipientNotFound">
      <CRow v-if="loading == false">
        <CCol sm="12" class="mb-4 mainDetail__content">
          <CRow>
            <CCol sm="12" md="12" lg="7" class="mainDetail__section sectionDetail">
              <CRow class="pr-lg-5">
                <!-- TODO Criar um componet wrapper para envolver os componetes menores dessa pagina - com header para titulo- slot de botoes -->
                <CCol sm="12">
                  <ResumeDetail />
                </CCol>
                <CCol sm="12" class="mainDetail__sectionItem">
                  <ContactNotes @addNewNote="addNewNote" />
                </CCol>
                <CCol sm="12" class="mainDetail__sectionItem">
                  <ContactInfo />
                </CCol>
                <CCol sm="12" class="mainDetail__sectionItem">
                  <ContactTags />
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="12" md="12" lg="5" class="mainDetail__section sectionDetail">
              <CRow>
                <CCol sm="12" class="mainDetail__sectionItem mainDetail__ContactFeed">
                  <ContactFeed :hasNewNote="notificationNewNote" />
                </CCol>
                <CCol sm="12" class="mainDetail__sectionItem">
                  <ContactKeys />
                </CCol>
                <CCol sm="12" class="mainDetail__sectionItem">
                  <ContactOptInOut />
                </CCol>
                <CCol sm="12" class="mainDetail__sectionItem">
                  <ContactEngagement />
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import ContactInfo from '../components/detail/ContactInfo'
import ResumeDetail from '../components/detail/ResumeDetail'
import ContactKeys from '../components/detail/ContactKeys'
import ContactOptInOut from '../components/detail/ContactOptInOut'
import ContactNotes from '../components/detail/ContactNotes'
import ContactEngagement from '../components/detail/ContactEngagement'
import ContactTags from '../components/detail/ContactTags'
import ContactFeed from '../components/detail/ContactFeed'

export default {
  name: 'AudienceDetail',
  components: {
    ContactInfo,
    ResumeDetail,
    ContactKeys,
    ContactOptInOut,
    ContactNotes,
    ContactEngagement,
    ContactTags,
    ContactFeed,
  },

  data() {
    return {
      messages: [],
      recipientNotFound: false,
      loading: false,
      notificationNewNote: 0,
    }
  },

  created() {
    this.getSchema()
  },

  destroyed() {
    this.notificationNewNote = 0
  },

  computed: {
    organizationId() {
      return this.$route.params.organizationId
    },
  },

  methods: {
    getSchema() {
      this.$store
        .dispatch('audience/getSchema', this.organizationId)
        .then(() => {
          this.getRecipient()
        })
        .catch((error) => {
          this.recipientNotFound = !error.response.data.success
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    getRecipient() {
      this.$store
        .dispatch('audience/getRecipientId', {
          organizationId: this.organizationId,
          recipientId: this.$route.params.id,
        })
        .catch((error) => {
          this.recipientNotFound = !error.response.data.success
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    addNewNote() {
      this.notificationNewNote += 1
    },
  },
}
</script>

<style lang="scss">
.mainDetail {
  &__sectionItem {
    .card {
      background: none;
      border: none;
      box-shadow: none !important;
    }

    border-bottom: 1px solid var(--gray-500);

    &:last-child {
      border: none;
    }
  }

  .titlePage {
    display: none;
  }

  a {
    cursor: pointer;
  }

  .back {
    text-decoration: none;
  }

  .form {
    .form__body {
      width: 100%;
      // height: auto;
      // max-height: 400px;
      padding: 0 1rem;
      // overflow: auto;
    }

    .form-group {
      display: flex;
      justify-content: center;
      align-items: center;

      label {
        flex: 0 0 40%;
        transition: all 500ms;
        font-weight: normal;
        font-size: 18px;
        margin-bottom: 0;
      }

      input,
      textarea {
        flex: 1 1;
        font-size: 18px;
        transition: all 500ms;
        resize: none;
      }
    }

    &--view {
      .wrapper-prepend {
        background: transparent;
      }

      .form-group {
        label {
          background: none;
        }

        input,
        textarea {
          background: none;
          box-shadow: none !important;
          border: none;
          resize: none;
          height: 40px;
          width: 100%;
        }
      }
    }
  }
}
</style>
